export default {
  get_company_detail: [],
  edit_dash: {},
};
